import { CONTACT_ANCHOR } from './site';

/**
 * Scrolls to the contact form on the current page and focuses its first field once settled.
 * Returns false when the page has no contact form, so the caller can navigate instead.
 */
export function scrollToContactForm() {
  const section = document.getElementById(CONTACT_ANCHOR);
  if (!section) return false;

  const reduceMotion =
    matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.motion === 'paused';
  const form = section.querySelector<HTMLElement>('.contact-panel') ?? section;
  form.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
  const firstField = section.querySelector<HTMLInputElement>('input:not([tabindex="-1"])');
  if (!firstField || !matchMedia('(pointer: fine)').matches) return true;

  let focused = false;
  const focusField = () => {
    if (focused) return;

    focused = true;
    window.removeEventListener('scrollend', focusField);
    firstField.focus({ preventScroll: true });
  };
  window.addEventListener('scrollend', focusField, { once: true });
  setTimeout(focusField, reduceMotion ? 0 : 1200);
  return true;
}
